import styled from 'styled-components';
import { Column } from 'components/layout';
import { ReactComponent as _Arrow } from 'styles/icons/arrow.svg';
import { color, typography } from 'styles/settings';
import { withModifiers } from 'utils/styles';

export const Container = styled(Column)`
  background-color: ${color.neutral.grayLight};
  ${typography.font.semiBold};
  color: ${color.brand.greenDark};
  display: flex;
  justify-content: flex-start;
  padding: 23px 0;
  position: relative;
`;

export const DropdownContainer = styled.div`
  flex: 1;
  position: absolute;
  top: 35px;
  left: -12px;
  min-width: 200px;
  z-index: 1;
`;

export const DropdownMenu = styled.div`
  align-items: center;
  background-color: ${color.neutral.grayLight};
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  padding-bottom: 7px;
  position: relative;
  top: 20px;

  :before {
    content: '';
    position: absolute;
    top: -8px;
    transform: rotateX(180deg);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid ${color.neutral.grayLight};
    clear: both;
  }
`;

export const OptionWrapper = styled.div`
  :hover {
    opacity: 0.8;
  }
`;

export const SelectedContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Arrow = styled(_Arrow)`
  height: 10px;
  width: 10px;
  margin-left: 8px;
  cursor: pointer;
  color: ${color.brand.greenDark};
  transition: transform 0.3s linear;

  ${withModifiers('$menuOpened')`
    transform: rotate(180deg);
  `}
`;

export const Option = styled.span`
  display: inline-block;
  background-color: ${color.neutral.white};
  width: 26px;
  height: 26px;
  -moz-border-radius: 16px;
  -webkit-border-radius: 16px;
  border-radius: 16px;

  :hover {
    border: 2px solid ${({ color }) => color};
  }

  :after {
    content: '';
    margin-top: 1px;
    margin-left: 1px;
    height: 24px;
    width: 24px;
    cursor: pointer;
    background-color: ${({ color }) => color};
    border-radius: 50%;
    display: inline-block;
  }
`;

export const Circle = styled.span`
  height: 24px;
  width: 24px;
  cursor: pointer;
  background-color: ${({ color }) => color};
  border-radius: 50%;
  display: inline-block;
`;

export const OptionLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 14px;
  word-break: break-all;
  text-align: center;
  ${withModifiers('$isSelected')`
    margin-bottom: 0; 
  `}
`;

export const Border = styled.span`
  border: 2px solid ${({ color }) => color};
  background-color: transparent;
  position: absolute;
  width: 26px;
  height: 26px;
  border-radius: 14px;
  opacity: 0;
  transition: opacity 0.5s;

  :hover {
    opacity: 1;
  }
`;
